<template>
  <vs-card>
    <div class="import-btn" style="text-align: center">

     <!--  <vx-tooltip text="Import Questions" position="right">
        <div class="import_icon_holder">
          <span 
            class="material-icons cursor-pointer"
            @click="isQuestionModal = true">help
          </span>
        </div>
      </vx-tooltip> -->
      <!-- <vs-button
        style="margin: 5px"
        class="mb-2"
        color="primary"
        type="filled"
        icon=""
        @click="isQuestionModal = true"
      >
        Import Questions
      </vs-button> -->


      <vx-tooltip color="primary" text="Import Exams" position="right">
        <div class="import_icon_holder">
          <span 
            class="material-icons cursor-pointer"
            @click="isAssignmentModaClose(4)">edit
          </span>
        </div>
      </vx-tooltip>
      <!-- <vs-button
        style="margin: 5px"
        class="mb-2"
        color="primary"
        type="filled"
        icon=""
        @click="isAssignmentModaClose(4)"
      >
        Import Exams
      </vs-button> -->

      <vx-tooltip color="primary" text="Import Homework" position="right">
        <div class="import_icon_holder">
          <span 
            class="material-icons cursor-pointer"
            @click="isAssignmentModaClose(2)">assignment
          </span>
        </div>
      </vx-tooltip>
        <!-- <vs-button
        style="margin: 5px"
        class="mb-2"
        color="primary"
        type="filled"
        icon=""
        @click="isAssignmentModaClose(2)"
      >
        Import HomeWork
      </vs-button> -->


      <vx-tooltip color="primary" text="Import Reports" position="right">
        <div class="import_icon_holder">
          <span 
            class="material-icons cursor-pointer"
            @click="isAssignmentModaClose(3)">insert_chart
          </span>
        </div>
      </vx-tooltip>
        <!-- <vs-button
        style="margin: 5px"
        class="mb-2"
        color="primary"
        type="filled"
        icon=""
        @click="isAssignmentModaClose(3)"
      >
        Import Reports
      </vs-button> -->

      <div  v-if="types== 'course'">
      <vx-tooltip color="primary" text="Import Lessons" position="right">
        <div class="import_icon_holder">
          <span 
            class="material-icons cursor-pointer"
            @click="isLessonModalClose()">menu_book
          </span>
        </div>
      </vx-tooltip>
      </div>
      <!-- <vs-button
      v-if="types== 'course'"
        style="margin: 5px"
        class="mb-2"
        color="primary"
        type="filled"
        icon=""
        @click="isLessonModalClose()"
      >
        Import Lessons
      </vs-button> -->

      <!-- {{lesson_file_index}} -->
<!-- {{types}} -->

      <div v-else>
      <vx-tooltip color="primary" text="Import Topic" position="right">
        <div class="import_icon_holder">
          <span 
            class="material-icons cursor-pointer"
            @click="isTopicModalClose()">font_download
          </span>
        </div>
      </vx-tooltip>
      </div>
        <!-- <vs-button
        v-else
        style="margin: 5px"
        class="mb-2"
        color="primary"
        type="filled"
        icon=""
        @click="isTopicModalClose()"
      >
        Import Topic
      </vs-button> -->
      <!-- {{isQuestionModal}}
      {{isAssignmentModal}} -->
    </div>
  </vs-card>     
</template>

<script>
export default {
  name:'ImportModule',
  data () {
    return {
      isQuestionModal: false,
      isAssignmentModal:false

    }
  },
  props:{
    lesson_file_index:{
      type:Number,
      default:null
    },
    types:{
      type:String,
      default:'course'

    }

  },
  beforeDestroy () {
    
  },
  methods:{
    isAssignmentModaClose (id) {
      
      
      const obj = {
        id,
        name:'isAssignmentModal',
        lesson_file_index:this.lesson_file_index

      }
      this.$emit('openQuestionModal', obj)

    },
    isLessonModalClose () {
      
       
      const obj = {
        
        name:'isLessonModal',
        lesson_file_index:this.lesson_file_index

      }
      this.$emit('openQuestionModal', obj)
    },
    isTopicModalClose () {
      
      const obj = {
        
        name:'isTopicModal',
        lesson_file_index:this.lesson_file_index

      }
      this.$emit('openQuestionModal', obj)
      
      
    }

  },
  watch:{
    isQuestionModal () {
      
      this.isQuestionModal = false
      const obj = {
        name:'isQuestionModal',
        lesson_file_index:this.lesson_file_index
      }
      this.$emit('openQuestionModal', obj)
    }
    // isAssignmentModal () {
    //   
    //   this.isAssignmentModal = false
    //   this.$emit('openQuestionModal', 'isAssignmentModal')
    // }
    
  }
//   computed:{
//     localValue : {
//       get () {
//         return this.value
//       },
//       set (value) {
//         this.$emit('input', value)
//       }
//     }
//   }
}
</script>
<style>
.import_icon_holder {
  display: flex;
}
.import_icon_holder .material-icons {
  color: rgba(var(--vs-primary), 1);
}
</style>